import { NgModule, inject } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';
import { NotFoundPage } from './pages/not-found/not-found.page';
import { ChatDesktopGuard } from './guards/chat-desktop.guard';
import { CustomPreloadStrategy } from './services/custom-preload-strategy';
import { AuthGuardService } from './providers/authGuard/auth-guard.service';

const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./pages/signin/signin.module').then((m) => m.SigninPageModule),
		data: { preload: true },
	},
	{
		path: 'sign-up',
		canActivate: [() => inject(Router).createUrlTree(['/login'], { queryParams: { tab: 'register' } })],
		loadChildren: () => import('./pages/signin/signin.module').then((m) => m.SigninPageModule),
	},
	{
		path: 'user/:user_pk',
		loadChildren: () => import('./pages/tabs/account/account.module').then((m) => m.AccountPageModule),
		pathMatch: 'full',
	},
	{
		path: 'new-chat',
		loadChildren: () => import('./pages/new-chat/new-chat.module').then((m) => m.NewChatPageModule),
	},
	{
		path: 'add-horse',
		loadChildren: () => import('./pages/edit-listing/edit-listing.module').then((m) => m.EditListingPageModule),
		canActivate: [AuthGuardService],
		data: { mode: 'create', listingType: 'horse' },
	},
	{
		path: 'privacy',
		loadChildren: () => import('./pages/tabs/settings/privacy/privacy.module').then((m) => m.PrivacyPageModule),
	},
	{
		path: 'blocked-users',
		loadChildren: () => import('./pages/tabs/chat/blocked-users/blocked-users.module').then((m) => m.BlockedUsersPageModule),
	},
	{
		path: 'archived-chats',
		loadChildren: () => import('./pages/tabs/chat/archived-chats/archived-chats.module').then((m) => m.ArchivedChatsPageModule),
	},
	{
		path: 'new-message',
		loadChildren: () => import('./pages/new-message/new-message.module').then((m) => m.NewMessagePageModule),
	},
	{
		path: 'tutorial',
		loadChildren: () => import('./pages/tutorial/tutorial.module').then((m) => m.TutorialPageModule),
	},
	{
		path: 'map',
		loadChildren: () => import('./pages/map/map.module').then((m) => m.MapPageModule),
	},
	{
		// Edit listing - must be before horse/:pk so Angular matches the more specific route
		path: 'horse/:pk/edit',
		loadChildren: () => import('./pages/edit-listing/edit-listing.module').then((m) => m.EditListingPageModule),
		canActivate: [AuthGuardService],
		data: { mode: 'edit', listingType: 'horse' },
	},
	{
		// Listing detail pages - at app level for proper safe area handling
		path: 'horse/:pk',
		loadChildren: () => import('./pages/listing/listing.module').then((m) => m.ListingPageModule),
	},
	{
		path: 'tack/:pk/edit',
		loadChildren: () => import('./pages/edit-listing/edit-listing.module').then((m) => m.EditListingPageModule),
		canActivate: [AuthGuardService],
		data: { mode: 'edit', listingType: 'tack' },
	},
	{
		path: 'tack/:pk',
		loadChildren: () => import('./pages/listing/listing.module').then((m) => m.ListingPageModule),
	},
	{
		path: '',
		loadChildren: () => import('./pages/tabs/tabs.module').then((m) => m.TabsPageModule),
	},
	{
		path: '**',
		component: NotFoundPage,
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: CustomPreloadStrategy,
			onSameUrlNavigation: 'ignore',
			// Enable location strategy for direct URL access
			useHash: false,
			// Important for SEO and social sharing
			initialNavigation: 'enabledBlocking',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
